import apiClient from "./apiInterceptor";

export const socialPostService = {
  getPosts: async (platform, configId) => {
    // configId: usercid for telegram, facebookId (UUID) for facebook
    const endpoint = `/${platform}/data/posts/${configId}`;
    const res = await apiClient.get(endpoint);
    return res?.data;
  },

  getPostsByType: async (platform, configId, type) => {
    const endpoint = `/${platform}/data/posts/${configId}/type/${type.toUpperCase()}`;
    const res = await apiClient.get(endpoint);
    return res?.data;
  },

  getPost: async (platform, id) => {
    const endpoint = `/${platform}/data/post/${id}`;
    const res = await apiClient.get(endpoint);
    return res?.data;
  },

  deletePost: async (platform, id) => {
    const endpoint = `/${platform}/data/post/${id}`;
    const res = await apiClient.delete(endpoint);
    return res?.data;
  },
};
